import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface EstadoVacioProps {
  icon: LucideIcon;
  titulo: string;
  detalle?: string;
  /** Acción principal sugerida (normalmente un botón). */
  accion?: ReactNode;
  className?: string;
}

/**
 * Aviso de «todavía no hay nada aquí».
 *
 * Antes era una línea de texto gris suelta en una tarjeta blanca, que en las
 * pantallas sin datos dejaba el portal entero en blanco y gris. Aquí el estado
 * vacío tiene su propio bloque con color de marca, el icono en un círculo y,
 * cuando aplica, la acción que lo resuelve (registrar la placa, escribir el
 * mensaje…), que es justo lo que el cliente necesita ver en ese momento.
 */
export function EstadoVacio({ icon: Icono, titulo, detalle, accion, className }: EstadoVacioProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-card border border-dashed border-brand-200 bg-gradient-to-b from-brand-50/70 to-white px-5 py-8 text-center',
        className,
      )}
    >
      <span className="flex size-12 items-center justify-center rounded-full bg-gradient-to-br from-brand-500 to-accent-500 text-white shadow-brand">
        <Icono className="size-6" aria-hidden="true" />
      </span>

      <div className="max-w-md">
        <p className="text-sm font-semibold text-ink-900">{titulo}</p>
        {detalle ? <p className="mt-1 text-sm text-ink-500">{detalle}</p> : null}
      </div>

      {accion ? <div className="mt-1">{accion}</div> : null}
    </div>
  );
}
